import { Component, EventEmitter, OnInit, Output, Input } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { courseCatalog } from '../../../../../data';

@Component({
  selector: 'course-rank-form',
  templateUrl: './course-rank-form.component.html',
  styleUrls: ['./course-rank-form.component.css'],
  standalone: false,
})
export class CourseRankFormComponent implements OnInit {
  @Output() pendingEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() courseRankFormOptions = new EventEmitter<string>();
  @Input() buttonCourseRank = 'rankCourses';

  public height!: string;

  public emptyInput: boolean = true;

  // observable string that observes for input value in the form field
  filteredCourses!: string[];

  // course catalog with just the code
  courseCatalogCode: string[] = [];

  // course catalog variable with code and name
  courseCatalogWithName: string[] = [];

  // subscription for data
  private subscription: Subscription = new Subscription();

  // variable to check if form is fully filled in
  isTargetCoursesEmpty: boolean = true;

  // variable to check if form is fully filled in
  isCourseHistoryEmpty: boolean = true;

  // array of strings => courses picked by user
  public targetCourses: string[] = [];

  // array of strings => courses picked by user
  public courseHistory: string[] = [];

  // mat-chip
  selectable = true;
  removable = true;

  // form control to get button toggle value and save it
  formOptions = new FormControl();

  /////////////////////////////////////////////////// FORM GROUP DECLARATION ///////////////////////////////////////////////////
  // courses form group
  public targetCoursesForm = new FormGroup({
    course_code: new FormControl(),
  });

  public courseHistoryForm = new FormGroup({
    course_code: new FormControl(),
    course_grade: new FormControl(),
  });

  constructor(private dialog: MatDialog) {}

  ngOnInit(): void {
    this.courseCatalogCode = courseCatalog.map(
      (course: { course_code: any; course_name: any }) =>
        `${course.course_code}`,
    );

    this.courseCatalogWithName = courseCatalog.map(
      (course: { course_code: any; course_name: any }) =>
        `${course.course_code}-${course.course_name}`,
    );

    // observable to observes for changes in the input filed for course name
    // For Course Recommender
    this.subscription.add(
      this.targetCoursesForm
        .get('course_code')!
        .valueChanges.pipe(
          startWith(''),
          map((value) => {
            this.filteredCourses = this.courseCatalogWithName.filter((course) =>
              course.toLowerCase().startsWith(value.toLowerCase()),
            );

            if (this.filteredCourses.length < 4) {
              this.height = this.filteredCourses.length * 50 + 'px';
            } else {
              this.height = '200px';
            }
          }),
        )
        .subscribe(),
    );

    // observable to observes for changes in the input filed for course name
    // For Course Recommender
    this.subscription.add(
      this.courseHistoryForm
        .get('course_code')!
        .valueChanges.pipe(
          startWith(''),
          map((value) => {
            this.filteredCourses = this.courseCatalogWithName.filter((course) =>
              course.toLowerCase().startsWith(value.toLowerCase()),
            );

            if (this.filteredCourses.length < 4) {
              this.height = this.filteredCourses.length * 50 + 'px';
            } else {
              this.height = '200px';
            }
          }),
        )
        .subscribe(),
    );
  }

  ngOnDestroy(): void {
    setTimeout(() => {
      this.subscription.unsubscribe();
    }, 3000);
  }

  rankCoursesFormSubmit() {
    // this.pendingEmitter.emit(true);
  }

  // split string into 2 parts [MAC2311, Calculus 1]
  getCourseCode(str: string) {
    return str.split('-')[0];
  }

  // add course to courses array
  addTargetCourses() {
    let code: string = '';

    for (let i = 0; i < this.courseCatalogWithName.length; i++) {
      if (
        this.targetCoursesForm.value.course_code ==
        this.courseCatalogWithName[i]
      ) {
        code = this.getCourseCode(this.courseCatalogWithName[i]);
      }
    }

    // join strings together for submission in backend
    // Example ==> MAC1105:A
    this.targetCourses.push(code);

    this.isTargetCoursesEmpty = false;

    // reset form values
    this.targetCoursesForm.setValue({ course_code: '' });
  }

  // remove course in courses[]
  removeTargetCourse(course: string): void {
    const index = this.targetCourses.indexOf(course);

    if (index >= 0) {
      this.targetCourses.splice(index, 1);
    }

    // if targetCourses is empty set var = true
    if (this.targetCourses.length === 0) {
      this.isTargetCoursesEmpty = true;
    }
  }

  // add course to courses array
  addCourseHistory() {
    let code: string = '';

    for (let i = 0; i < this.courseCatalogWithName.length; i++) {
      if (
        this.courseHistoryForm.value.course_code ==
        this.courseCatalogWithName[i]
      ) {
        code = this.getCourseCode(this.courseCatalogWithName[i]);
      }
    }

    // join strings together for submission in backend
    // Example ==> MAC1105:A
    let str = code + ':' + this.courseHistoryForm.value.course_grade;
    this.courseHistory.push(str);

    this.isCourseHistoryEmpty = false;

    // reset form values
    this.courseHistoryForm.setValue({ course_code: '', course_grade: '' });
  }

  // remove course in courses[]
  removeCourseHistory(course: string): void {
    const index = this.courseHistory.indexOf(course);

    if (index >= 0) {
      this.courseHistory.splice(index, 1);
    }

    // if coursesTaken is empty set var = true
    if (this.courseHistory.length === 0) {
      this.isCourseHistoryEmpty = true;
    }
  }

  // raise an event with value from the toggle button
  checkGroup(group: string) {
    this.courseRankFormOptions.emit(group);
  }

  // check course grade dropdown field to see if it's empty
  //if empty add course button will be disabled
  checkDropdown(input: any) {
    if (input.value !== '') {
      this.emptyInput = false;
    } else {
      this.emptyInput = true;
    }
  }

  // close popup dialog after form is submitted
  closeDialog() {
    this.dialog.closeAll();
  }

  // function to check if isTargetCoursesEmpty and if the form is fully filled
  // if it is submit button will be enabled for submission
  disabledSubmitButton() {
    if (!this.isTargetCoursesEmpty) {
      return false;
    } else {
      return true;
    }
  }

  // Error message when user leaves form fields empty
  getErrorMessage() {
    return 'You must enter a value';
  }
}
